var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416384 0.41662C0.646479 0.186527 1.01954 0.186527 1.24963 0.416619L9.5821 8.74901C9.81219 8.9791 9.81219 9.35216 9.5821 9.58225C9.352 9.81234 8.97895 9.81234 8.74885 9.58225L0.416384 1.24986C0.18629 1.01977 0.18629 0.646712 0.416384 0.41662Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58338 0.417364C9.81347 0.647457 9.81347 1.02051 9.58338 1.2506L1.25091 9.583C1.02081 9.8131 0.647756 9.8131 0.417661 9.583C0.187567 9.35291 0.187567 8.97986 0.417662 8.74976L8.75013 0.417364C8.98022 0.187271 9.35328 0.187271 9.58338 0.417364Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDefault);
export default __webpack_public_path__ + "static/media/close-default.d841b3980eaa03006ac3026da714fb78.svg";
export { ForwardRef as ReactComponent };